import config from 'config';
import { http_client } from './api';

const getList = async (page = null, perPage = null, sort = null, orderBy = null, search = null) => {
  return http_client
    .get(
      config.apiUrl +
        'tahunajaran?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};
const getListArchive = async (page = null, perPage = null, sort = null, orderBy = null, search = null) => {
  return http_client
    .get(
      config.apiUrl +
        'tahunajaran/archive?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'tahunajaran', data).then((response) => {
    return response.data;
  });
};
const read = async (id) => {
  return http_client.get(config.apiUrl + 'tahunajaran/' + id).then((response) => {
    return response.data;
  });
};
const update = async (id, data) => {
  return http_client.patch(config.apiUrl + 'tahunajaran/' + id, data).then((response) => {
    return response.data;
  });
};
const del = async (id) => {
  return http_client.delete(config.apiUrl + 'tahunajaran/' + id).then((response) => {
    return response.data;
  });
};

const changeStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'tahunajaran/' + id + '/status', data).then((response) => {
    return response.data;
  });
};

const changeActiveStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'tahunajaran/' + id + '/active', data).then((response) => {
    return response.data;
  });
};
const TahunajaranService = {
  getList,
  getListArchive,
  create,
  read,
  update,
  del,
  changeStatus,
  changeActiveStatus
};

export default TahunajaranService;
